import { Description } from '../../../common/public-api';

/**
 * Basic API business error code definition
 *
 * @export
 * @class DefinedErrorCode
 */
export class DefinedErrorCode {
  @Description('Library.ErrorCode.StatusCodeError')
  public static readonly statusCodeError = 'TRNS.StatusCodeError';

  @Description('Library.ErrorCode.HasProcessQueuing')
  public static readonly hasProcessQueuing = 'TRNS.HasProcessQueuing';

  @Description('Library.ErrorCode.TransactionIdNotFound')
  public static readonly transactionIdNotFound = 'TRNS.TransactionIdNotFound';

  @Description('Library.ErrorCode.TransactionFailure')
  public static readonly transactionFailure = 'TRNS.TransactionFailure';

  @Description('Library.ErrorCode.UserNotExist')
  public static readonly userNotExist = 'TRNS.UserNotExist';
}
